// configuration for initial locale per language/country pair or language
const LOCALE_CONFIG: Record<string, string> = {
  'en-gb': 'en-gb',
  'es-es': 'es-es',
  'es-mx': 'es',
}

export const LOCALE_KEY = 'app.locale'

export function getCurrentLocale (language: string, country: string): string {
  const queryLocale = new URLSearchParams(window.location.search).get('locale')?.toLowerCase()
  const storedLocale = localStorage.getItem(LOCALE_KEY)

  const locale = queryLocale || storedLocale

  const localeLangugage = locale?.split('-')[0]
  if (localeLangugage === language) {
    return (locale && LOCALE_CONFIG[locale]) || language
  }
  return LOCALE_CONFIG[`${language}-${country}`] || LOCALE_CONFIG[language] || language
}

export function saveLocale (locale: string): void {
  localStorage.setItem(LOCALE_KEY, locale)
}
